module.exports = __webpack_public_path__ + "static/media/fivethirtyeight.com_live-blog_2016-election-results-coverage__plot@2x.0f14ca8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/fivethirtyeight.com_live-blog_2016-election-results-coverage__plot@2x.png
// module id = 392
// module chunks = 0